var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_1693_26281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.109 37.4118C62.412 22.4836 36.319 19.7568 27.4694 8.17297C16.4268 -6.28149 -3.42654 12.8408 4.61114 29.1585C7.57381 35.1731 11.8696 40.9578 17.8547 45.7331C34.4366 58.9633 31.806 52.3399 47.109 37.4118Z",
    fill: "url(#paint0_linear_1693_26281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.109 37.4118C62.412 22.4836 36.319 19.7568 27.4694 8.17297C16.4268 -6.28149 -3.42654 12.8408 4.61114 29.1585C7.57381 35.1731 11.8696 40.9578 17.8547 45.7331C34.4366 58.9633 31.806 52.3399 47.109 37.4118Z",
    stroke: "#52CB74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_26281",
    x: 0.244141,
    y: 0.55957,
    width: 54.0791,
    height: 54.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1693_26281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1693_26281",
    x1: 13.1138,
    y1: 9.1589,
    x2: 29.4752,
    y2: 65.1815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#FFF744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E13827"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap13);
export default __webpack_public_path__ + "static/media/heatMap13.eb522d376c322751fb9de86ec03b0455.svg";
export { ForwardRef as ReactComponent };